var _rect, _line, _rect2, _rect3, _line2, _rect4, _line3, _rect5, _line4, _rect6, _line5, _rect7, _line6, _rect8, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoardroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.3999,
    y: 10.6006,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(90 22.3999 10.6006)",
    fill: "#6E6B7B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.1001,
    y1: 11.1006,
    x2: 23.1001,
    y2: 13.1006,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 6.2002,
    width: 17,
    height: 12,
    rx: 1,
    fill: "#6E6B7B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.2002,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#6E6B7B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 1.5,
    x2: 4.5,
    y2: 1.5,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(1 0 0 -1 2 22)",
    fill: "#6E6B7B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 2 22.2002)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2.2002,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#6E6B7B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 1.5,
    x2: 9.5,
    y2: 1.5,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(1 0 0 -1 7 22)",
    fill: "#6E6B7B"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 7 22.2002)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2.2002,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#6E6B7B"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 1.5,
    x2: 14.5,
    y2: 1.5,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(1 0 0 -1 12 22)",
    fill: "#6E6B7B"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 12 22.2002)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardroom);
export default __webpack_public_path__ + "static/media/boardroom.6771e3bc3b98e6abed33f58ea2c26fb8.svg";
export { ForwardRef as ReactComponent };